/* 棚 */
import React from 'react';
import { Collapse,Card } from 'react-bootstrap';

interface Props {
  label: string;
  // content: JSX.Element | JSX.Element[] | null;
  is_open: boolean;
  handleClick: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

const Shelf: React.FC<Props> = ({ label, is_open, handleClick, children }) => {
  return (
    <Card className="shelf mx-auto px-0 col-11 col-xs-10 col-lg-9">
      <Card.Header className="shelf-header" onClick={handleClick} aria-expanded={is_open}>
        {label}
        <span className="triangle">{is_open ? '▼' : '▶'}</span>
      </Card.Header>
      <Collapse className="collapse-body" in={is_open}>
        <div>
          <Card.Body className="p-2">
            <div>{children}</div>
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default Shelf;
